// extracted by mini-css-extract-plugin
export default {"formBody":"GenericSupplierDesignFields_formBody__8nLlu"};